import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 14.418V16.7c0 .694-.368 1.335-.955 1.706q-5.046 3.187-10.093 0A2.03 2.03 0 0 1 6 16.7v-2.28a.1.1 0 0 1 .148-.088l3.672 2.008c.66.36 1.42.55 2.18.55s1.52-.19 2.18-.55l3.672-2.008a.1.1 0 0 1 .149.087m1.936-6.513-6.47-3.532a3.06 3.06 0 0 0-2.932 0l-6.47 3.532c-1.418.773-1.418 2.808 0 3.583l6.47 3.53a3.06 3.06 0 0 0 2.932 0l6.47-3.53-.686.375V16a.75.75 0 0 0 1.5 0v-5.33c.503-.931.235-2.193-.814-2.765"
    }, null, -1)
  ])))
}
export default { render: render }